if (!customElements.get('sidebar-menu')) {
  class SidebarMenu extends HTMLElement {
    constructor() {
      super();

      this.isOpen = false;
      this.toggleButton = this.querySelector('.sidebar-menu__open');
      this.innerContent = this.querySelector('.sidebar-menu__content--inner');
      this.tabs = this.querySelectorAll('.sidebar-menu__tab');
      this.tabContents = this.querySelectorAll('.sidebar-menu__main--content');

      this.toggleMenu = this.toggleMenu.bind(this);
      this.handleTabClick = this.handleTabClick.bind(this);

      this.init();
    }

    init() {
      // Attach click event for opening/closing the sidebar menu
      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', this.toggleMenu);
      }

      // Attach click events for each tab
      this.tabs.forEach((tab) => {
        const button = tab.querySelector('.sidebar-menu__tab-btn');
        if (button) {
          button.addEventListener('click', (e) => this.handleTabClick(e, tab));
        }
      });

      // Ensure the first tab's content is open on initialization
      this.activateTab(this.tabs[0]);
    }

    toggleMenu() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.innerContent.classList.add('is-visible'); // Show the inner content
        this.toggleButton.innerHTML = this.getCloseIcon();
      } else {
        this.innerContent.classList.remove('is-visible'); // Hide the inner content
        this.toggleButton.innerHTML = this.getOpenIcon();
      }
    }

    handleTabClick(event, tab) {
      event.preventDefault();
      this.activateTab(tab);
    }

    activateTab(tab) {
      const index = tab.dataset.index;

      // Remove "open" class from all tabs and tab contents
      this.tabs.forEach((t) => t.classList.remove('open'));
      this.tabContents.forEach((content) => content.classList.remove('open'));

      // Add "open" class to the clicked tab and its corresponding content
      tab.classList.add('open');
      const contentToShow = this.querySelector(
        `.sidebar-menu__main--content[data-index="${index}"]`
      );
      if (contentToShow) {
        contentToShow.classList.add('open');
      }
    }

    getOpenIcon() {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.33333 2.66667C0.596954 2.66667 0 2.06971 0 1.33333C0 0.596954 0.596954 0 1.33333 0H22.6667C23.403 0 24 0.596954 24 1.33333C24 2.06971 23.403 2.66667 22.6667 2.66667H1.33333ZM0 8C0 8.73638 0.596954 9.33333 1.33333 9.33333H14.6667C15.403 9.33333 16 8.73638 16 8C16 7.26362 15.403 6.66667 14.6667 6.66667H1.33333C0.596953 6.66667 0 7.26362 0 8ZM0 14.6667C0 15.403 0.596953 16 1.33333 16H22.6667C23.403 16 24 15.403 24 14.6667C24 13.9303 23.403 13.3333 22.6667 13.3333H1.33333C0.596953 13.3333 0 13.9303 0 14.6667Z" fill="#00304A"/>
        </svg>
      `;
    }
    
    getCloseIcon() {
      return `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M18.6261 3.25385C19.0166 2.86333 19.0166 2.23017 18.6261 1.83964L18.1603 1.37385C17.7698 0.98333 17.1366 0.98333 16.7461 1.37385L10.7069 7.41297C10.3164 7.8035 9.68325 7.8035 9.29273 7.41297L3.25361 1.37385C2.86309 0.98333 2.22992 0.98333 1.8394 1.37385L1.37361 1.83964C0.983086 2.23017 0.983086 2.86333 1.37361 3.25385L7.41273 9.29298C7.80326 9.6835 7.80325 10.3167 7.41273 10.7072L1.37361 16.7463C0.983086 17.1368 0.983086 17.77 1.37361 18.1605L1.8394 18.6263C2.22992 19.0168 2.86309 19.0168 3.25361 18.6263L9.29273 12.5872C9.68326 12.1967 10.3164 12.1967 10.7069 12.5872L16.7461 18.6263C17.1366 19.0168 17.7698 19.0168 18.1603 18.6263L18.6261 18.1605C19.0166 17.77 19.0166 17.1368 18.6261 16.7463L12.5869 10.7072C12.1964 10.3167 12.1964 9.6835 12.5869 9.29297L18.6261 3.25385Z" fill="#00304A" stroke="#00304A"/>
      </svg>
      `;
    }
  }

  customElements.define('sidebar-menu', SidebarMenu);
}